import { render, staticRenderFns } from "./FundTable-PositionsFof.vue?vue&type=template&id=5fc0050f&scoped=true&"
import script from "./FundTable-PositionsFof.vue?vue&type=script&lang=js&"
export * from "./FundTable-PositionsFof.vue?vue&type=script&lang=js&"
import style0 from "./FundTable-PositionsFof.vue?vue&type=style&index=0&id=5fc0050f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc0050f",
  null
  
)

export default component.exports